export const MOVEMENT_DASHBOARD_PATH = '/results/dashboard';
export const USER_GUIDE =
  'https://support.p-44.com/hc/en-us/categories/6973969614365-Movement';
